<template>
  <div ref="layout" v-loading="loading" class="page-form page-base">
    <h3 class="title">材料计划单</h3>

    <div class="form-container">
      <div class="tools">
        <form-button @click="$router.go(-1)">返回</form-button>
      </div>
      <el-form
        ref="form"
        disabled
        inline
        size="mini"
        label-width="100px"
        :model="conditions"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="材料计划编号">
              <el-input
                v-model="conditions.packpl_id"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="packpl_type" label="单据类型">
              <el-select
                v-model="conditions.packpl_type"
              >
                <el-option
                  v-for="item in selectDataOptions['A0012']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="customer" label="订单客户">
              <el-input v-model="conditions.customer" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select
                v-model="conditions.custypenumber"
              >
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.name1"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元">
              <el-input
                v-model="conditions.zzfld00001h_text"
              />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item label="预约">
              <el-checkbox v-model="conditions.preorder" true-label="1" false-label="0" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"

                type="textarea"
                rows="4"
                clearable
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input
                v-model="conditions.uname"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.datum"
                disabled
                value-format="yyyyMMdd"
                type="date"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="单据状态">
              <el-input
                v-model="conditions.status"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="材料计划明细" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        />
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiGetMaterialPlanDetail } from '@/api/sap/material-plan'
export default {
  data() {
    return {
      conditions: {
        id: '',
        packpl_id: '', // 单据编号
        packpl_type: '', // 单据类型
        customer: '', // 客户编号
        custypenumber: '', // 客户类型
        name1: '', // 客户名称
        zzfld00001h: '', // 营销单元
        uname: '', // 创建人
        datum: '', // 创建时间
        status: '新建', // 单据状态
        preorder: '0' // 是否预约
      },
      currentRow: {},
      selectDataOptions: {},
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 80 },
          { field: 'product_id', title: '产品编码', width: 200 },
          { field: 'description', title: '产品描述' },
          { field: 'wlybrand', title: '品牌' },
          { field: 'planqty_box', title: '计划数量（箱）' },
          { field: 'planqty_bottle', title: '计划数量（盒）' },
          { field: 'planqty_ton', title: '计划数量（吨）' },
          { field: 'status', title: '状态', width: 80 },
          { field: 'remark', title: '备注' }
        ],
        data: [],
        delData: []
      }
    }
  },
  created() {
    // 材料计划单据类型
    this.getSelectDictDataOrigin('A0012')
    // 材料计划单据状态
    this.getSelectDictDataOrigin('A0013')
    this.getSelectDictDataOrigin('A0009')
    // 是否选项
    this.getSelectDictDataOrigin('B0099')
    this.conditions.packpl_id = this.$route.query.code
    this.handleQueryByCode()
  },

  methods: {
    // 根据id查询材料计划信息
    async handleQueryByCode() {
      this.loading = true
      try {
        const res = await apiGetMaterialPlanDetail({ iv_packpl_id: this.conditions.packpl_id })
        Object.assign(this.conditions, res.head)
        this.gridOptions.data = res.item
      } catch (error) {
        //
      }
      this.loading = false
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          const rows = response.data.Rows.filter(item => {
            return item.value !== 'ZM03'
          })
          this.$set(this['selectDataOptions'], dictcode, rows)
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 0 20px 20px;
  background: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/material-plan-manage/components/materialPLanOrderCheck.vue